import type { Features } from '../types';

export const site = {
  title: 'Lõdvik OÜ — Autoremont ja rehvivahetus Pärnus',
  description:
    'Autoremont Pärnus: rehvivahetus, diagnostika ja remont. Lõdvik OÜ, Vana-Sauga 42. Helista +372 5626 6798.',
  canonical: 'https://lõdvik.ee/',
  locale: 'et',
  hero: {
    title: 'Sõidukite diagnostika ja remont Pärnus',
    subtitle:
      'Veermik, hooldus, veakontroll ja rehvivahetus — läbipaistvad hinnad, asjatundlik töö.',
    kicker: 'Lõdvik — Autoremont',
  },
  nav: {
    services: 'Teenused',
    pricing: 'Hinnakiri',
    brands: 'Brandid',
    contact: 'Kontakt',
    privacy: 'Privaatsus',
  },
  cta: {
    call: 'Helista',
    calculate: 'Arvuta hind',
    enquire: 'Saada päring',
    email: 'Kirjuta meile',
    directions: 'Ava Google Maps',
    directionsApple: 'Ava Apple Maps',
    copy: 'Kopeeri kokkuvõte',
    send: 'Saada',
  },
  trust: {
    location: 'Pärnu',
    quality: 'Asjatundlik remont',
    brands: 'Euroopa ja Jaapani autod',
  },
  calculator: {
    title: 'Hinnakalkulaator',
    lead: 'Valige teenus ja saage orienteeruv hind enne helistamist.',
    tire: 'Rehvid',
    hourly: 'Tunnid',
    fixed: 'Muud',
    estimate: 'Orienteeruv hind',
    /** Short professional tag under the estimate label */
    estimateDependsTag: 'Sõltub vea ulatusest ja töö mahust',
    moreInfo: 'Lisainfo',
    hideInfo: 'Peida lisainfo',
    steelFlatSize: 'Plekkvelg — hind ei sõltu suurusest',
    vehicle: 'Sõiduk',
    passenger: 'Sõiduauto',
    vanSuv: 'Kaubik / maastur',
    rim: 'Velg',
    steel: 'Plekkvelg',
    alloy: 'Valuvelg',
    size: 'Suurus',
    hours: 'Tunnid',
    service: 'Teenus',
    empty:
      'Selle valiku jaoks hinda ei leitud. Proovige teist suurust või võtke ühendust.',
    perHour: '/h',
    from: 'al.',
    copyShort: 'Kopeeri',
    copied: 'Kopeeritud',
  },
  priceTable: {
    title: 'Hinnakiri',
    lead: 'Läbipaistvad hinnad — alati koos KM-ga.',
    general: 'Üldised teenused',
    tirePassenger: 'Rehvivahetus — sõiduautod',
    tireVan: 'Rehvivahetus — kaubikud / maasturid',
    service: 'Teenus',
    price: 'Hind',
  },
  brands: {
    title: 'Töötame brändidega',
    lead: 'Euroopa ja Jaapani sõidukid — asjatundlik hooldus ja remont.',
  },
  about: {
    title: 'Meie lähenemine',
  },
  contact: {
    title: 'Kontakt',
    lead: 'Helistage, kirjutage või saatke päring — vastame esimesel võimalusel.',
    address: 'Aadress',
    phone: 'Telefon',
    email: 'E-post',
    hours: 'Lahtiolekuajad',
  },
  form: {
    name: 'Nimi',
    plate: 'Auto registrinumber',
    phone: 'Telefoni number',
    email: 'Email',
    message: 'Sõnum',
    success: 'Aitäh! Võtame teiega peagi ühendust.',
    error: 'Saatmine ebaõnnestus. Helistage palun või proovige uuesti.',
    consent:
      'Saates nõustute, et võtame teiega seoses päringuga ühendust. Vt privaatsuspoliitika.',
    required: 'Kohustuslik väli',
    invalidEmail: 'Palun sisestage kehtiv e-posti aadress',
  },
  footer: {
    rights: 'Kõik õigused kaitstud.',
  },
  notFound: {
    title: 'Lehte ei leitud',
    lead: 'See aadress ei ole meie saidil olemas.',
    home: 'Avalehele',
  },
  sticky: {
    services: 'Teenused',
    pricing: 'Hinnakiri',
    contact: 'Kontakt',
  },
} as const;

export const features: Features = {
  showCalculator: true,
  showContactForm: true,
  showBrandLogos: false,
  showMapIframe: true,
};
